import { cn, getStatusColor } from "~/lib/utils";

interface Props {
  status: string;
  className?: string;
}
const TableBadge = ({ status, className }: Props) => {
  if (status === "Closed") {
    return (
      <div
        className={cn(
          "bg-white border border-[#d1d5db] text-[#374151] inline-flex items-center justify-center gap-2 rounded-[24px] px-[12px] py-[4px] text-center text-[14px] font-Medium",
          className,
        )}
      >
        <span>Closed</span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        `${getStatusColor(status)} inline-flex items-center justify-center gap-2 rounded-full px-3 py-1 text-center text-sm`,
        className,
      )}
    >
      <span>
        {status === "Ready for Review"
          ? "Pending Approval"
          : status}
      </span>
    </div>
  );
};

export default TableBadge;
